<ng-content></ng-content>
<div class="edit-icon" *ngIf="!readonly">
    <clr-icon shape="edit"></clr-icon>
</div>
